import AdminView from '@/views/AdminView.vue';
import { SignInView, ControlPanelView } from '@/views/admin';
import { useAuthStore } from '@/stores';
import Tr from '@/i18n/translation';
import { CommonForm, ImageForm } from '@/components/admin';
import {
  RsvpCommonForm,
  RsvpLangForm,
  RsvpFormChooser,
} from '@/components/admin/rsvp';
import {
  EventCommonForm,
  EventLangForm,
  EventFormChooser,
} from '@/components/admin/event';
import GKSFormChooser from '../components/admin/gks/GKSFormChooser.vue';
import GKSCommonForm from '../components/admin/gks/GKSCommonForm.vue';
import GKSLangForm from '../components/admin/gks/GKSLangForm.vue';
import BingoFormChooser from '@/components/admin/bingo/BingoFormChooser.vue';
import BingoCommonForm from '@/components/admin/bingo/BingoCommonForm.vue';
import BingoLangForm from '@/components/admin/bingo/BingoLangForm.vue';
import SaveDateFormChooser from '@/components/admin/saveDate/SaveDateFormChooser.vue';
import SaveDateCommonForm from '@/components/admin/saveDate/SaveDateCommonForm.vue';
import SaveDateLangForm from '@/components/admin/saveDate/SaveDateLangForm.vue';

const rsvpForms = [
  {
    path: 'common',
    name: 'RsvpCommonForm',
    component: RsvpCommonForm,
  },
  {
    path: 'lang',
    name: 'RsvpLangForm',
    component: RsvpLangForm,
  },
];

const eventForms = [
  {
    path: 'common',
    name: 'EventCommonForm',
    component: EventCommonForm,
  },
  {
    path: 'lang',
    name: 'EventLangForm',
    component: EventLangForm,
  },
];

const gksForms = [
  {
    path: 'common',
    name: 'GKSCommonForm',
    component: GKSCommonForm,
  },
  {
    path: 'lang',
    name: 'GKSLangForm',
    component: GKSLangForm,
  },
];

const bingoForms = [
  {
    path: 'common',
    name: 'BingoCommonForm',
    component: BingoCommonForm,
  },
  {
    path: 'lang',
    name: 'BingoLangForm',
    component: BingoLangForm,
  },
];

const saveDateForms = [
  {
    path: 'common',
    name: 'SaveDateCommonForm',
    component: SaveDateCommonForm,
  },
  {
    path: 'lang',
    name: 'SaveDateLangForm',
    component: SaveDateLangForm,
  },
];

const adminForms = [
  {
    path: 'event',
    name: 'EventForm',
    component: EventFormChooser,
    children: eventForms,
  },
  {
    path: 'common',
    name: 'CommonForm',
    component: CommonForm,
  },
  {
    path: 'image',
    name: 'ImageForm',
    component: ImageForm,
  },
  {
    path: 'rsvp',
    name: 'RsvpForm',
    component: RsvpFormChooser,
    children: rsvpForms,
  },
  {
    path: 'gks',
    name: 'GKSForm',
    component: GKSFormChooser,
    children: gksForms,
  },
  {
    path: 'bingo',
    name: 'BingoForm',
    component: BingoFormChooser,
    children: bingoForms,
  },
  {
    path: 'save-date',
    name: 'SaveDateForm',
    component: SaveDateFormChooser,
    children: saveDateForms,
  },
];

export default {
  path: 'admin',
  component: AdminView,
  redirect: Tr.i18nRoute({ name: 'Home' }),
  children: [
    {
      path: '/:locale?/sign-in',
      name: 'SignIn',
      component: SignInView,
    },
    {
      path: 'panel',
      name: 'ControlPanel',
      beforeEnter: async (_to, _from, next) => {
        const { checkAdmin, logout } = useAuthStore();
        const isAdmin = await checkAdmin();
        if (isAdmin) {
          next();
        } else {
          logout();
          next(Tr.i18nRoute({ name: 'Home' }));
        }
      },
      component: ControlPanelView,
      children: adminForms,
    },
  ],
};
